import type { ComplianceStatsFocus } from '../complianceCount';
import { complianceStatsPath } from '../complianceFocus';

export type ComplianceCountPrintFilters = {
  vesselId?: string;
  withinDays?: string;
};

export function complianceCountPrintPath(
  focus: ComplianceStatsFocus,
  filters: ComplianceCountPrintFilters = {},
): string {
  const qs = new URLSearchParams();
  if (filters.vesselId?.trim()) qs.set('vesselId', filters.vesselId.trim());
  if (filters.withinDays?.trim()) qs.set('withinDays', filters.withinDays.trim());
  const s = qs.toString();
  return `${complianceStatsPath(focus)}/print${s ? `?${s}` : ''}`;
}

export function complianceCountListApiUrl(params: URLSearchParams): string {
  const today = new Date().toISOString().slice(0, 10);
  const qs = new URLSearchParams({
    withinDays: params.get('withinDays')?.trim() || '90',
    periodFrom: today,
    periodTo: today,
  });
  const vesselId = params.get('vesselId')?.trim();
  if (vesselId) qs.set('vesselId', vesselId);
  return `/crew/reports/statistics?${qs.toString()}`;
}

export function complianceCountBackPath(focus: ComplianceStatsFocus): string {
  return complianceStatsPath(focus);
}
